import React from 'react';
import { IconButton, IconButtonProps } from '@fiverr-private/button';
import { theme } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';

export type Direction = 'left' | 'right';

interface LightboxArrowProps extends IconButtonProps {
  children: IconButtonProps['children'];
  direction: Direction;
  onClick: IconButtonProps['onClick'];
  'aria-label': IconButtonProps['aria-label'];
  dataTestId?: string;
}

const LightboxArrow = ({ children, direction, onClick, dataTestId, 'aria-label': ariaLabel }: LightboxArrowProps) => (
  <Container position="fixed" top="50%" transform="translate(0%, -50%)" {...{ [direction]: theme.spacing['8'] }}>
    <IconButton
      size="lg"
      intent="primary"
      shape="circle"
      aria-label={ariaLabel}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </IconButton>
  </Container>
);

export default LightboxArrow;
